import React, { Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  neighboursGameCompleted,
  patchGameNeighbours,
} from "../../actions/game.action";
import CountryInputForm from "../gadgets/CountryInputForm";
import GuessResultList from "../gadgets/GuessResultList";
import GuessNeighbourRow from "../gadgets/GuessNeighbourRow";
import SingleCountry from "../gadgets/SingleCountry";
import { toast } from "react-toastify";

import { checkGuessAlpha2Codes } from "../../utils";
import { useTranslation } from "react-i18next";

import countries from "../../constants/countries";
import BlankRows from "../gadgets/BlankRows";

const NeighboursPage = () => {
  const { t } = useTranslation();

  const dispatch = useDispatch();
  const { neighbours, countryOfToday } = useSelector(({ game }) => game);

  const setSearchString = (searchString) => {
    dispatch(patchGameNeighbours({ searchString }));
  };

  const handleGuess = (newGuess) => {
    const isCorrect = checkGuessAlpha2Codes(
      [...neighbours.guesses, newGuess],
      countryOfToday.borders,
    );

    if (isCorrect) {
      dispatch(neighboursGameCompleted());
      toast.success(t("Congratulations!"));
    }

    if (neighbours.guesses.length < neighbours.guessLimit) {
      dispatch(
        patchGameNeighbours({
          guesses: [...neighbours.guesses, newGuess],
        }),
      );
    }
  };

  return (
    <Fragment>
      <SingleCountry
        header={t("Do you know neighbours of", {
          count: countryOfToday?.borders?.length,
          country: countryOfToday?.name,
        })}
        Alpha2Codes={countryOfToday?.borders}
        completed={neighbours.completed}
      />
      <GuessResultList
        results={neighbours.guesses}
        limitRow={neighbours.guessLimit}
        completed={neighbours.completed}
        rowTemplate={GuessNeighbourRow}
      />
      {!neighbours.completed && (
        <>
          <div className="w-full cursor-pointer rounded bg-slate-300 p-1 transition-all duration-300 dark:bg-slate-600 dark:hover:bg-majky-500">
            <CountryInputForm
              rows={countries}
              results={neighbours.guesses}
              value={neighbours.searchString}
              onChange={setSearchString}
              onGuess={handleGuess}
            />
          </div>
          <BlankRows
            count={neighbours.guessLimit - neighbours.guesses.length - 1}
          />
        </>
      )}
    </Fragment>
  );
};

export default NeighboursPage;
